import styled from 'styled-components'
import { COLOR } from '../../assets/constants/constants'

export const ContainerBackButton = styled.div`
  width: 100%;
  height: auto;
`;

export const LanguageDiv = styled.div`
  @media (max-width: 767px) {
    overflow: auto;
    max-height: calc(100vh - 209px);
  }
  
  @media (min-width: 768px) {
    overflow: auto;
  }
`;

export const StyledLanguage = styled.p`
  text-transform: uppercase;
  color: ${p => p.evidence ? COLOR.tertiaty : COLOR.secondary};
  font-family: 'Amorin Sans Serif';
  font-size: 23.5px;
  letter-spacing: 1px;
  margin-bottom: 28px;
  transition: all .3s ease;
  cursor: pointer;

  &:hover {
    &:not(.active){
      color: ${COLOR.quaternary};
    }
  }
`;

export const BackButton = styled.div`
  display: flex;
  width: 100%;
  height: 25px;
  margin-bottom: 18px;
  cursor: pointer;
  transition: all .3s ease;

  &:hover {
    color: ${COLOR.primary};
    fill: ${COLOR.primary};
  };

  p {
    font-size: 17px;
    letter-spacing: .4px;
    font-family: 'Amorin Sans Book';
    margin-bottom: 0;
  };

  svg {
    margin: 4px 9px 0 -4px;
  };
`;
